import type { ReactNode } from "react";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";

// The shared shell that wraps every view, on both the server (entry-server.tsx)
// and the client (main.tsx). Anything every page needs around it — providers,
// context, and app-wide chrome — belongs here so the SSR and hydration trees
// stay identical. The active locale is loaded/activated on the shared i18n
// instance before render.
export function Shell({ children }: { children: ReactNode }) {
	return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
